/**
 * A Project can go through the following flow of statuses after being created
 *
 * PENDING -> IN_PROGRESS -> FINALIZED -> COMPLETED
 *
 * PENDING -> REJECTED
 *
 * [any] -> CLOSED
 */
export enum ServiceProjectStatusEnum {
  PENDING = "PENDING",
  IN_PROGRESS = "IN PROGRESS",
  FINALIZED = "FINALIZED",
  COMPLETED = "COMPLETED",
  REJECTED = "REJECTED",
  CLOSED = "CLOSED",
}

/**
 * Statues that represent whether a Service Project is Open.
 * e.g: User should not be able to purchase a Service if a Project of that Service is already Open
 */
export const ServiceProjectOpenStatues: ServiceProjectStatusEnum[] = [
  ServiceProjectStatusEnum.PENDING,
  ServiceProjectStatusEnum.IN_PROGRESS,
  ServiceProjectStatusEnum.FINALIZED,
];

/**
 * Statues that represent whether a Service Project is Active.
 * e.g: Updates to the Project can only be made while it is Active
 */
export const ServiceProjectActiveStatues: ServiceProjectStatusEnum[] = [
  ServiceProjectStatusEnum.IN_PROGRESS,
  ServiceProjectStatusEnum.FINALIZED,
];

/**
 * Statues that represent whether a Service Project is being or was worked on
 * Used to decide if two users are Associates
 */
export const ServiceProjectInitiatedStatues: ServiceProjectStatusEnum[] = [
  ServiceProjectStatusEnum.IN_PROGRESS,
  ServiceProjectStatusEnum.FINALIZED,
  ServiceProjectStatusEnum.COMPLETED,
];
